
export const Formatting = {}

Formatting.install = function (Vue, options) {
  Vue.prototype.$formatDuration = (value) => {
    return formatDuration(value)
  }
  Vue.prototype.$formatDistance = (value) => {
    return formatDistance(value)
  }
  Vue.prototype.$formatDateTime = (value) => {
    return formatDateTime(value)
  }
  Vue.prototype.$formatDate = (value) => {
    return formatDate(value)
  }
  Vue.prototype.$formatTime = (value) => {
    return formatTime(value)
  }
}

export function formatDuration(value) {
  var sec_num = parseInt(value, 10); // don't forget the second param
  var hours   = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
  var seconds = sec_num - (hours * 3600) - (minutes * 60);

  if (hours   < 10) {hours   = "0"+hours;}
  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}

  if (hours > 0) {
    return hours+'h '+minutes+'m '+seconds+'s';
  } else if (minutes > 0) {
    return minutes+'m '+seconds+'s';
  } else {
    return seconds+'s';
  }
}

export function formatDistance(value) {
  if (!value) {
    return "0 km"
  } else {
    return (value / 1000).toFixed(1) + ' km'
  }
}

export function formatDateTime(value) {
  if (!value) {
    return ""
  }

  let dateString = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toISOString().split("T")

  return dateString[0] + ' ' + dateString[1].split(".")[0]
}

export function formatDate(value) {
  if (!value) {
    return ""
  }

  let dateString = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toISOString().split("T")

  return dateString[0]
}

export function formatTime(value) {
  if (!value) {
    return ""
  }

  let dateString = new Date(value.getTime() - (value.getTimezoneOffset() * 60000)).toISOString().split("T")

  return dateString[1].split(".")[0]
}
